<div class="modal-content" data-testid="SUBSYS4_LOADER_BOX">
	<img data-testid="SUBSYS4_LOADER_IMG" [src]="LOADER_URL" alt="loading" class="logo-loading">
</div>